import { connect, type ConnectedProps } from 'react-redux';

import { getIsWhitelabel, getIsMobile } from 'src/store/view/selectors';

import { HeaderSkeleton } from './HeaderSkeleton';

const mapStateToProps = (state) => ({
  isWhiteLabel: getIsWhitelabel(state),
  isMobile: getIsMobile(state),
});

export const connector = connect(mapStateToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(HeaderSkeleton);
